/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CreatePaymentLinkLineItemValidationError,
  CreatePaymentLinkLineItemValidationError$inboundSchema,
  CreatePaymentLinkLineItemValidationError$Outbound,
  CreatePaymentLinkLineItemValidationError$outboundSchema,
} from "./createpaymentlinklineitemvalidationerror.js";

export type CreatePaymentLinkLineItemsValidationError = {
  items?: { [k: string]: CreatePaymentLinkLineItemValidationError } | undefined;
};

/** @internal */
export const CreatePaymentLinkLineItemsValidationError$inboundSchema: z.ZodType<
  CreatePaymentLinkLineItemsValidationError,
  z.ZodTypeDef,
  unknown
> = z.object({
  items: z.record(CreatePaymentLinkLineItemValidationError$inboundSchema)
    .optional(),
});
/** @internal */
export type CreatePaymentLinkLineItemsValidationError$Outbound = {
  items?:
    | { [k: string]: CreatePaymentLinkLineItemValidationError$Outbound }
    | undefined;
};

/** @internal */
export const CreatePaymentLinkLineItemsValidationError$outboundSchema:
  z.ZodType<
    CreatePaymentLinkLineItemsValidationError$Outbound,
    z.ZodTypeDef,
    CreatePaymentLinkLineItemsValidationError
  > = z.object({
    items: z.record(CreatePaymentLinkLineItemValidationError$outboundSchema)
      .optional(),
  });

export function createPaymentLinkLineItemsValidationErrorToJSON(
  createPaymentLinkLineItemsValidationError:
    CreatePaymentLinkLineItemsValidationError,
): string {
  return JSON.stringify(
    CreatePaymentLinkLineItemsValidationError$outboundSchema.parse(
      createPaymentLinkLineItemsValidationError,
    ),
  );
}
export function createPaymentLinkLineItemsValidationErrorFromJSON(
  jsonString: string,
): SafeParseResult<
  CreatePaymentLinkLineItemsValidationError,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      CreatePaymentLinkLineItemsValidationError$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'CreatePaymentLinkLineItemsValidationError' from JSON`,
  );
}
